import React, { Component, Fragment } from 'react';
import moment from 'moment';
import PropTypes from 'proptypes';
import Modal from 'react-modal';
import MakePayment from './MakePayment';
import HelpfulLinks from '../../lib/helpfulLinks/HelpfulLinks';
import TripAddOns from '../../screens/UserProfile/TripAddOns';
import TripDetails from '../../screens/UserProfile/TripDetails';
import { formatTripName, formatDate } from './../../../helpers/TripHelper';
import DeleteItemModal from './DeleteItemModal';
import FundRaiseSideBar from '../../lib/fundraiseSideBar/FundRaiseSideBar';
import { Link } from 'react-router-dom';

export default class MakeDeposit extends Component {
  state = {
    currentAddOns: this.props.currentAddOns,
    activeModal: null,
    tripId: this.props.trip ? this.props.trip.id : '',
    trip: this.props.trip ? this.props.trip : '',
    tripIndex: this.props.user.trips.map(trip => trip.id).indexOf(this.props.tripId),
    detailsToggled: false,
    hasPaidAnyAmount: false,
    hasPaidMinFundraiseAmount: false,
  };

  componentWillUnmount() {
    this.setState({
      hasPaidAnyAmount: false,
    });
  }

  setMakeDepositState = () => {
    this.setState({
      hasPaidAnyAmount: true,
      hasPaidMinFundraiseAmount: true,
    });
  };

  // setOpportunityState = (index, newState) => {
  //   // TODO: remove comment
  //   // this.state.trips[index] = newState;
  //   // this.setState({ trips: [...this.state.trips] });
  //   const newTripState = this.state.trips;
  //   newTripState[index] = newState;
  //   this.setState({ trips: newTripState });
  // };

  toggleWidget = (e, id) => {
    e.preventDefault();

    const widget = document.getElementById(id);

    const widgetIndicator = document.getElementById(`${id}-indicator`);

    const { offsetHeight } = document.getElementById(`${id}-content`);

    if (widget.clientHeight === 0) {
      widget.style.height = offsetHeight + 12 + 'px';
      widgetIndicator.innerHTML = '-';
    } else {
      widgetIndicator.innerHTML = '+';
      widget.style.height = 0 + 'px';
    }
  };

  // addTripAddOn = addOn => {
  //   const { currentAddOns } = this.state;

  //   currentAddOns.push(addOn);

  //   this.setState({
  //     currentAddOns
  //   });
  // };

  deleteTripAddOn = (e, addOnId, tripId, unitPrice, tripIndex, addOnIndex, addOn) => {
    e.preventDefault();

    this.props.deleteTripAddOn(tripId, tripIndex, addOnIndex, addOn);
  };

  openModalDeleteOrChangeTrip = modalName => {
    this.setState({
      activeModal: modalName,
    });
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
    });
  };

  changeTripHandler = () => {
    this.props.setParentState('replaceOpportunityId', this.props.tripId);
    this.props.history.push('/trip-selection');
  };

  render() {
    const {
      trip,
      tripIndex,
      userName,
      trip: {
        id,
        destination,
        paymentDue,
        payments,
        availableAddOns,
        currentAddOns,
        displaySeatsLeft,
      },
      // setParentTripValue,
      setOpportunityState,
      tripId,
      handleRouting,
      openModal,
      history,
      deleteTripHandler,
      setParentState,
    } = this.props;

    const hasPaidAnyAmount = trip.payments.tripBalance < trip.payments.tripAmount;

    const hasPaidMinFundraiseAmount = trip.payments.tripBalance <= trip.payments.tripAmount - 50;

    return (
      <Fragment>
        <div className="row make-deposit">
          <div className="col-md-12 margin-bottom-container">
            <h2>
              {userName ? `${userName}, ` : ''}
              {!hasPaidMinFundraiseAmount ? 'Add a deposit to secure your spot!' : 'spot reserved'}
              {displaySeatsLeft > 0 && displaySeatsLeft < 10 ? (
                <span className="error">
                  <br />
                  {' ( '}
                  {displaySeatsLeft === 1
                    ? 'Hurry, only 1 Seat Left! '
                    : 'Hurry, only ' + displaySeatsLeft + ' Seats Left! '}
                  )
                </span>
              ) : (
                ''
              )}
            </h2>
            <h3 className="h1-style muted">
              {trip.destination},{' '}
              {formatDate(
                moment(trip.startDate, 'MMMM Do, YYYY'),
                moment(trip.endDate, 'MMMM Do, YYYY')
              )}
              !{' '}
            </h3>
            <div className="row">
              {!hasPaidMinFundraiseAmount && (
                <button className="micro highlighted" onClick={() => this.changeTripHandler()}>
                  Change Trip
                </button>
              )}
              {!hasPaidMinFundraiseAmount && (
                <button className="micro highlighted" onClick={() => this.changeTripHandler()}>
                  Change to Package & Save
                </button>
              )}
              {!hasPaidMinFundraiseAmount && (
                <button
                  className="micro highlighted"
                  onClick={() => this.openModalDeleteOrChangeTrip('deleteItemModalForm')}
                >
                  Add an Additional Trip
                </button>
              )}
              {hasPaidMinFundraiseAmount && (
                <Link to="/trip-selection" className="button micro highlighted" type="button">
                  Add an Additional Trip
                </Link>
              )}
            </div>
            {Object.keys(trip.content).length ? (
              <Fragment>
                <button
                  className="btn-plain-text small"
                  onClick={() => {
                    this.setState(({ detailsToggled }) => ({
                      detailsToggled: !detailsToggled,
                    }));
                  }}
                >
                  {this.state.detailsToggled ? 'Hide' : 'Show'} Trip Video/Details
                </button>
                {this.state.detailsToggled ? (
                  <TripDetails detailsToggled={this.state.detailsToggled} trip={trip} />
                ) : (
                  ''
                )}
              </Fragment>
            ) : (
              ''
            )}
            <TripAddOns
              viewMode="limited"
              hasPaidDeposit={false}
              addTripAddOn={this.props.addTripAddOn}
              updateTripCost={() => {}}
              tripIndex={tripIndex}
              tripId={tripId}
              availableAddOns={availableAddOns}
              // setParentTripValue={setParentTripValue}
              setParentTripValue={() => {}}
              setOpportunityState={setOpportunityState}
              user={this.props.user}
            />
            {currentAddOns.length ? (
              <div
                className={`col-md-12 flex no-padding-col ${
                  !availableAddOns.length ? 'top-padding' : ''
                }`}
              >
                <div className="addons-heading-container inline">
                  <h4 className="success lighter">Added to my trip:</h4>
                </div>
                <div className="addons-container inline">
                  {currentAddOns.map((addOn, addOnIndex) => (
                    <div key={addOn.id}>
                      {addOn.tripId === this.state.tripId ? (
                        <h4 className="muted addon-name">
                          <strong className="success">+</strong>{' '}
                          {formatTripName(addOn.name, addOn.addOnStartDate, addOn.addOnEndDate)}{' '}
                        </h4>
                      ) : (
                        ''
                      )}
                      <button
                        onClick={() =>
                          this.props.deleteTripAddOn(
                            addOn.tripId,
                            this.state.tripIndex,
                            addOnIndex,
                            addOn
                          )
                        }
                        className="btn-plain-text muted"
                        disabled={this.props.isProcessing}
                      >
                        remove
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="col-md-6">
            {/* <Fragment>
              <h4 class="muted"><span class="icon-container icon-container-left warning-icon"></span> There are no seats left on this trip.  To be placed on the waiting list complete your deposit, or give us a call.</h4>
            </Fragment> */}
            <MakePayment
              trip={this.state.trip}
              tripId={id}
              tripIndex={tripIndex}
              tripName={destination}
              payments={payments}
              history={history}
              additionalTripCost={this.props.additionalTripCost}
              handleRouting={this.props.handleRouting}
              setOpportunityState={this.props.setOpportunityState}
              user={this.props.user}
              setTripState={this.props.setTripState}
              setMakeDepositState={this.setMakeDepositState}
              setParentState={this.props.setParentState}
            />
            {hasPaidMinFundraiseAmount || this.state.hasPaidMinFundraiseAmount ? (
              <div className="extra-padding-container">
                <FundRaiseSideBar userId={this.props.user.id} tripId={trip.id} />
              </div>
            ) : (
              ''
            )}
            <div className="extra-padding-container">
              <TripAddOns
                viewMode="comprehensive"
                hasPaidDeposit={false}
                addTripAddOn={this.props.addTripAddOn}
                updateTripCost={() => {}}
                tripIndex={tripIndex}
                tripId={tripId}
                availableAddOns={availableAddOns}
                // setParentTripValue={setParentTripValue}
                setParentTripValue={() => {}}
                setOpportunityState={setOpportunityState}
                user={this.props.user}
                isProcessing={this.props.isProcessing}
              />
            </div>
          </div>
          <div className="col-md-6">
            <h3 className="h1-style muted margin-bottom-text">
              Six Reasons Why You Shouldn't Wait!
            </h3>
            <div className="styled-container">
              <div className="row">
                <button
                  onClick={e => this.toggleWidget(e, 'widget-1')}
                  className="btn-plain-text widget-btn"
                >
                  <div className="widget-heading-container">
                    <h4 className="widget-heading">
                      1. Your deposit is good for life & fully refundable within 72 hours!
                    </h4>
                  </div>
                  <div className="widget-indicator-container">
                    <h4>
                      <strong id="widget-1-indicator">+</strong>
                    </h4>
                  </div>
                </button>
              </div>
              <div id="widget-1" className="widget collapsed-widget">
                <p id="widget-1-content" className="body-text no-margin-text">
                  We know plans can change, and we're flexible. Your good-for-life deposit is fully
                  refundable within 72-hours of payment. If your plans change after that, just let
                  us know{' '}
                  <b>before {moment(paymentDue, 'MMMM Do, YYYY').format('MMMM Do, YYYY')}</b> and
                  you can transfer your deposit to any future trip&#33; See our{' '}
                  <button onClick={openModal} className="btn-plain-text">
                    terms and conditions
                  </button>{' '}
                  for our cancellation policy.
                </p>
              </div>
            </div>
            <div className="styled-container">
              <div className="row">
                <button
                  onClick={e => this.toggleWidget(e, 'widget-2')}
                  className="btn-plain-text widget-btn"
                >
                  <div className="widget-heading-container">
                    <h4 className="widget-heading">
                      2. Your spot is guaranteed with a deposit&#33;
                    </h4>
                  </div>
                  <div className="widget-indicator-container">
                    <h4>
                      <strong id="widget-2-indicator">+</strong>
                    </h4>
                  </div>
                </button>
              </div>
              <div id="widget-2" className="widget collapsed-widget">
                <p id="widget-2-content" className="body-text no-margin-text">
                  After you put down your good-for-life deposit, your spot on the trip is
                  guaranteed&#33; You can put down your add-on deposit with your trip deposit or
                  later, either one is a-okay&#33; If you need to change your trip date, just
                  contact us.
                </p>
              </div>
            </div>
            <div className="styled-container">
              <div className="row">
                <button
                  onClick={e => this.toggleWidget(e, 'widget-3')}
                  className="btn-plain-text widget-btn"
                >
                  <div className="widget-heading-container">
                    <h4 className="widget-heading">3. Fundraise for your deposit!</h4>
                  </div>
                  <div className="widget-indicator-container">
                    <h4>
                      <strong id="widget-3-indicator">+</strong>
                    </h4>
                  </div>
                </button>
              </div>
              <div id="widget-3" className="widget collapsed-widget">
                <p id="widget-3-content" className="body-text no-margin-text">
                  If you can&#39;t pay the full deposit today, put down a minimum of $95 to start
                  fundraising for your deposit! This will give you access to our Fundraising Toolkit
                  and Endorsement letter to help raise funds for your trip. Continue making payments
                  and once you have paid the deposit, your spot will be reserved. Also, this
                  let&#39;s us know that you&#39;re planning to go on the trip and can reach out if
                  the trip starts to get full. Please note funds placed toward your trip to meet
                  your deposit are nonrefundable.
                </p>
              </div>
            </div>
            <div className="styled-container">
              <div className="row">
                <button
                  onClick={e => this.toggleWidget(e, 'widget-4')}
                  className="btn-plain-text widget-btn"
                >
                  <div className="widget-heading-container">
                    <h4 className="widget-heading">
                      4. Refer-a-friend to earn free travel & your Fundraising Toolkit&#33;
                    </h4>
                  </div>
                  <div className="widget-indicator-container">
                    <h4>
                      <strong id="widget-4-indicator">+</strong>
                    </h4>
                  </div>
                </button>
              </div>
              <div id="widget-4" className="widget collapsed-widget">
                <p id="widget-4-content" className="body-text no-margin-text">
                  Money should not be a barrier for going on a trip! You can (1){' '}
                  <strong>earn trip discounts by referring your friend(s)</strong> and (2){' '}
                  <strong>fundraise for your trip!</strong> After we receive your deposit, we&#39;ll
                  email you to join our Refer-a-friend program to invite your friends and both earn
                  trip discounts! You'll also receive an endorsement letter to fundraise,
                  fundraising tools from past travelers, advice, and MORE&#33;
                </p>
              </div>
            </div>
            <div className="styled-container">
              <div className="row">
                <button
                  onClick={e => this.toggleWidget(e, 'widget-5')}
                  className="btn-plain-text widget-btn"
                >
                  <div className="widget-heading-container">
                    <h4 className="widget-heading">
                      5. We&#39;ll make space for your friend (and you'll earn!)&#33;
                    </h4>
                  </div>
                  <div className="widget-indicator-container">
                    <h4>
                      <strong id="widget-5-indicator">+</strong>
                    </h4>
                  </div>
                </button>
              </div>
              <div id="widget-5" className="widget collapsed-widget">
                <p id="widget-5-content" className="body-text no-margin-text">
                  Waiting on a friend to put down your deposit? Don&#39;t&#33; Solidify your spot,
                  then join our Refer-a-friend program so you both can save! You&#39;ll receive a
                  unqiue referral code and when someone uses your referral link to book their trip,
                  you'll both receive trip discounts! Don't worry - we can also add your friend to
                  the same trip, , as long as there isn't a waitlist, so tell your friend not to
                  wait too long&#33; We know it&#39;s important to be on the same trip, so we&#39;ll
                  do our best to make it happen.
                </p>
              </div>
            </div>
            <div className="styled-container">
              <div className="row">
                <button
                  onClick={e => this.toggleWidget(e, 'widget-6')}
                  className="btn-plain-text widget-btn"
                >
                  <div className="widget-heading-container">
                    <h4 className="widget-heading">6. Purchase your add-on(s) later&#33;</h4>
                  </div>
                  <div className="widget-indicator-container">
                    <h4>
                      <strong id="widget-6-indicator">+</strong>
                    </h4>
                  </div>
                </button>
              </div>
              <div id="widget-6" className="widget collapsed-widget">
                <p id="widget-6-content" className="body-text no-margin-text">
                  The most important part is to make sure you get on a trip&#33; Then, you can put a
                  deposit down for an add-on or upgrade to a package later. Log in to your GIVE
                  Profile anytime to pay the add-on deposit - you don&#39;t have to pay both
                  deposits at the same time.
                </p>
              </div>
            </div>
            <div className="row helpfulLinksContainer chevrons-right-texture">
              <div className="col-md-12 styled-container margin-bottom-container">
                <HelpfulLinks />
              </div>
            </div>
            <div>
              <p className="muted body-text">
                Have any other questions? Please feel free to call us at{' '}
                <a href="tel:12069737991">206.973.7991</a> or visit our{' '}
                <a
                  href="https://www.givevolunteers.org/contact/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  contact page
                </a>
                .
              </p>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.activeModal === 'deleteItemModalForm'}
          onRequestClose={this.closeModal}
          className="deleteModal"
          overlayClassName="overlay"
        >
          <DeleteItemModal
            hasPaidAnyAmount={hasPaidAnyAmount}
            tripId={this.state.tripId}
            history={history}
            setParentState={setParentState}
            handleRouting={handleRouting}
            closeModal={this.closeModal}
            deleteTripHandler={deleteTripHandler}
          />
        </Modal>
        {hasPaidMinFundraiseAmount && (
          <div className="row">
            <div className="col-md-12">
              <button
                className="btn-plain-text margin-center muted small"
                onClick={() => this.openModalDeleteOrChangeTrip('deleteItemModalForm')}
              >
                Change Volunteer Location and/or Trip Date
              </button>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

MakeDeposit.propTypes = {
  setAppState: PropTypes.func,
  setTripState: PropTypes.func,
  deleteTripHandler: PropTypes.func,
  setOpportunityState: PropTypes.func,
  setParentState: PropTypes.func.isRequired,
  setParentTripValue: PropTypes.func,
  handleRouting: PropTypes.func,
  openModal: PropTypes.func.isRequired,
  userName: PropTypes.string,
  trip: PropTypes.shape({
    paymentDue: PropTypes.string,
    id: PropTypes.string,
    payments: PropTypes.shape({
      percentageComplete: PropTypes.string,
      tripBalance: PropTypes.num,
      tripAmount: PropTypes.num,
    }),
  }).isRequired,
  tripIndex: PropTypes.number.isRequired,
  tripId: PropTypes.string.isRequired,
  addTripAddOn: PropTypes.func.isRequired,
  deleteTripAddOn: PropTypes.func.isRequired,
  currentAddOns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      addOnStartDate: PropTypes.string,
      addOnEndDate: PropTypes.string,
      tripAddOnId: PropTypes.string,
      tripId: PropTypes.string,
      unitPrice: PropTypes.number,
    })
  ).isRequired,
  isProcessing: PropTypes.bool.isRequired,
  userProps: PropTypes.shape({
    birthdate: PropTypes.string,
    gender: PropTypes.string,
    nationality: PropTypes.string,
  }),
};

MakeDeposit.defaultProps = {
  userName: '',
  setTripState: () => {},
  deleteTripHandler: () => {},
  handleRouting: () => {},
  setOpportunityState: () => {},
  setParentTripValue: () => {},
  setAppState: () => {},
  userProps: {},
};
